import store from '@/store';

export default async (to, from, next) => {
  if (to.matched.some(record => record.meta.adminAuth)) {
    // TODO check user is actually an admin IF other roles added.
    if (!store.getters['auth/user']) {
      return next({
        path: '/admin/login',
        query: { redirect: to.fullPath }
      });
    }

    return next();
  }

  return next();
};
